export default function (val) {
  if (!val) return
  const data = {}
  const a = val.split('-')
  data.departFrom = a[0]
  console.log(data.departFrom)
  data.cityCodes = []
  if (a[3] != 'Any') {
    a[3].split(',').forEach((item) => {
      data.cityCodes.push(item)
    })
  }
  // data.cityCodes = a[3];
  data.countryCode = a[4]
  let b = a[7].split('.')
  data.startDate = new Date(b[2], (b[1] * 1 - 1), b[0])
  b = a[9].split('.')
  data.endDate = new Date(b[2], (b[1] * 1 - 1), b[0])
  data.durations = []
  for (let i = a[11] * 1; i <= a[13] * 1; i++) {
    data.durations.push(i)
  }
  data.adults = a[15]
  data.ChildsAges = []
  if (a[17] != 'no') {
    const b = a[17].split(',')
    b.forEach((i) => {
      data.ChildsAges.push(i)
    })
  }
  data.mealTypes = []
  if (a[19] != 'Any') {
    b = a[19].split(',')
    b.forEach((item) => {
      data.mealTypes.push(item.replace(' ', '+'))
    })
  }
  data.HotelCategories = []
  if (a[21] != 'Any') {
    b = a[21].split(',')
    b.forEach((item) => {
      data.HotelCategories.push(item)
    })
  }
  data.Currency = a[23].toUpperCase()
  data.Suppliers = []
  if (a[25] != 'Any') {
    b = a[25].split(',')
    b.forEach((item) => {
      data.Suppliers.push(item.toUpperCase())
    })
  }
  return data
}
